import { useEffect, useState } from 'react';
import { Button, Col, Row, Spin } from 'antd';
import React from 'react';
import { FormActions } from '../../components';
import { goToClassifiers } from '../../utils/gotoLink';
import { withTranslation } from 'react-i18next';
import { NAMESPACES } from '../../i18n';
import goExpirationChangeDate from '../../constants/parameters/goExpirationChangeDate';
import {
  classifiersGoExpirationChange,
  classifiersGoExpirationFetch,
} from '../../actions/actionHelpers/endpoints';
import dayjs from '../../utils/dayjs';

function ParameterGoExpirationEdit({ t }) {
  const [classifier, setClassifier] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    classifiersGoExpirationFetch()
      .then(
        (response) =>
          setClassifier({
            value: dayjs(response.data.value, 'DD.MM.YYYY', true).format(
              'YYYY-MM-DD'
            ),
          }) & setLoading(false)
      )
      .catch((error) => console.error(error) & setLoading(false));
  }, []);

  function save() {
    setLoading(true);
    classifiersGoExpirationChange({
      value: dayjs(classifier.value, 'YYYY-MM-DD', true).format('DD.MM.YYYY'),
    })
      .then(() => setLoading(false))
      .catch((error) => console.error(error) & setLoading(false));
  }

  return (
    <Spin spinning={loading} className="search-results-container">
      <h1>{t('parameterGoExpirationTitle')}</h1>
      <form>
        <Row gutter={32}>
          <Col span={24}>
            <input
              type={'date'}
              className="date-field"
              name={goExpirationChangeDate.VALUE}
              value={classifier.value}
              onChange={(e) => setClassifier({ value: e.target.value })}
            />
          </Col>
        </Row>
        <FormActions>
          <Button onClick={goToClassifiers}>{t('buttonBack')}</Button>
          <Button type="primary" onClick={save}>
            {t('buttonSave')}
          </Button>
        </FormActions>
      </form>
    </Spin>
  );
}

export default withTranslation(NAMESPACES.classifiers)(
  ParameterGoExpirationEdit
);
